import { Show } from "solid-js";
export function ModuleCard(props: {
  title: string;
  state: string;
  detail: string;
  meta: string;
  href?: string;
  cta?: string;
  children?: import("solid-js").JSX.Element;
}) {
  return (
    <article
      class={`signal-module-card ${props.href ? "is-live" : "is-quiet"}`}
    >
      <div>
        <span class="signal-card-label">{props.title}</span>
        <h2>{props.state}</h2>
        <p>{props.detail}</p>
      </div>
      {props.children}
      <div class="signal-module-card-foot">
        <small>{props.meta}</small>
        <Show when={props.href && props.cta}>
          <a href={props.href} class="signal-text-action">
            {props.cta}
          </a>
        </Show>
      </div>
    </article>
  );
}
